import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { fixtureGradePageConfig } from "./fixtureGradePageConfig";

export const fixtureGradeRecordDefinition: RecordDefinition = {
  path: "/fixture-grade",
  entityName: "dwfixturegrade",
  listRoute: "/fixture-grades",
  backTitle: "Back to fixture grades",
  allowedRoles: administratorRoles,
  config: fixtureGradePageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Fixture Grade",
    newRecordTitle: "New Fixture Grade",
  },
};
